import React from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';

import { createFormFieldsByIdGetter, createFormValidationFn } from 'client/helpers/formikHelpers';

import SrButton, { SR_BUTTON_THEME_ADOBE_YELLOW } from 'client/components/SrButton/SrButton';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

import './UPOrdersHitlistTable.less';

const formFields = [
  {
    id: 'reason',
    title: 'Reason',
    label: '(required to continue)',
    type: 'long_text',
    properties: {
      placeholder: 'Please indicate why you think this automated order failed.',
    },
    validations: ['required'],
  },
];

const UPOrderHitlistTableFailedAutomatedOrderBanner = ({ onSubmit = () => {} }) => {
  const getFormFieldsById = createFormFieldsByIdGetter(formFields);

  return (
    <div styleName="automationFailedBanner">
      <div styleName="errorDetails">
        <span styleName="title">Failed to Process This Order Automatically</span>
        <span styleName="details">
          Screenshots contain valuable information that can help diagnose the issue.
        </span>
      </div>
      <Formik
        initialValues={{
          reason: '',
        }}
        onSubmit={onSubmit}
        validate={(values) => {
          return createFormValidationFn(formFields)(values);
        }}
        render={(formikBag) => {
          return (
            <Form>
              <SrFormikField
                formField={getFormFieldsById('reason')}
                formikBag={formikBag}
                theme={SR_FIELD_THEME_ADOBE}
              />
              <SrButton type="submit" margin="8px 0 0 0" theme={SR_BUTTON_THEME_ADOBE_YELLOW}>
                Submit
              </SrButton>
            </Form>
          );
        }}
      />
    </div>
  );
};

UPOrderHitlistTableFailedAutomatedOrderBanner.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

UPOrderHitlistTableFailedAutomatedOrderBanner.displayName =
  'UPOrderHitlistTableFailedAutomatedOrderBanner';

export default UPOrderHitlistTableFailedAutomatedOrderBanner;
